// extracted by mini-css-extract-plugin
export default {"caption":"caption--POwbA"};